__turbopack_context__.v({
  "CouponInfo": "ClaimScreen-module-scss-module__L7HhqW__CouponInfo",
  "DealTimeContainer": "ClaimScreen-module-scss-module__L7HhqW__DealTimeContainer",
  "Description": "ClaimScreen-module-scss-module__L7HhqW__Description",
  "DiscountCondition": "ClaimScreen-module-scss-module__L7HhqW__DiscountCondition",
  "DiscountDescription": "ClaimScreen-module-scss-module__L7HhqW__DiscountDescription",
  "DiscountDescriptionWrapper": "ClaimScreen-module-scss-module__L7HhqW__DiscountDescriptionWrapper",
  "FormSection": "ClaimScreen-module-scss-module__L7HhqW__FormSection",
  "TermsAndPolicy": "ClaimScreen-module-scss-module__L7HhqW__TermsAndPolicy",
  "ThumbnailContainer": "ClaimScreen-module-scss-module__L7HhqW__ThumbnailContainer",
  "ThumbnailScale": "ClaimScreen-module-scss-module__L7HhqW__ThumbnailScale",
  "ThumbnailShadow": "ClaimScreen-module-scss-module__L7HhqW__ThumbnailShadow",
  "Title": "ClaimScreen-module-scss-module__L7HhqW__Title",
  "Wrapper": "ClaimScreen-module-scss-module__L7HhqW__Wrapper",
});
